import * as Yup from 'yup';
import { ContractorStatus, ContractorType } from '../entities';

export interface ContractorForm {
  label: string;
  contactEmail: string;
  type: ContractorType;
  status: ContractorStatus;
  applicationFee: string;
}

export type ContractorFormShape = {
  [key in keyof ContractorForm]?: any;
};

export const schema = Yup.object().shape<ContractorFormShape>({
  label:  Yup.string().required('Digite o nome'),
  contactEmail: Yup.string().required('Digite o email de contato'),
  type: Yup.mixed().required('Selecione o tipo'),
  applicationFee: Yup.string().required('Digite a taxa'),
});
